import React, { Component, createRef } from "react";
import GoogleMapReact, { fitBounds } from "google-map-react";

import Car from "../assets/car.svg";
import Hotel from "../assets/hotel.svg";

import { Link } from "react-router-dom";
import settings from "../settings";

const AnyReactComponent = ({ text, img }) => (
  <div className="marker">
    {img && <img src={img} alt="marker icon" />}
    {text}
  </div>
);

class GPS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      size: { width: 0, height: 0 },
      markers: [],
      bounds: {
        ne: { lat: 0, lng: 0 },
        sw: { lat: 0, lng: 0 },
      },
      dataload: null,
      isLoaded: false,
      eta: null,
    };
    this.updateSize = this.updateSize.bind(this);
    this.containerRef = createRef();
  }

  componentDidMount() {
    this.updateSize();
    this.loadData();
    window.addEventListener("resize", this.updateSize);
    const dataload = setInterval(this.loadData.bind(this), 1000 * 60 * 5.1);
    this.setState({ dataload });
  }

  componentWillUnmount() {
    clearInterval(this.state.dataload);
    window.removeEventListener("resize", this.updateSize);
  }

  calculateSize() {
    if (this.containerRef.current) {
      const containerWidth = this.containerRef.current.offsetWidth;
      const containerHeight = this.containerRef.current.offsetHeight;
      return { width: containerWidth, height: containerHeight };
    }
    return { width: 0, height: 0 };
  }

  updateSize() {
    this.setState({ size: this.calculateSize() }, this.updateBounds);
  }

  async loadData() {
    this.setState({ isLoading: true });
    let markData = null;
    await fetch(
      settings.server_url +
        "get_next_delivery_location/" +
        window.sessionStorage.getItem("sid")
    )
      .then((res) => res.json())
      .then((response) => {
        // Check if myLocation is null or undefined before processing
        if (
          !response.myLocation ||
          response.myLocation[0] === null ||
          response.myLocation[1] === null
        ) {
          this.setState({ isLoaded: true });
          return;
        }

        markData = [
          {
            user: response.locationName,
            lat: response.myLocation[0],
            lon: response.myLocation[1],
            img: Hotel,
          },
        ];

        if (response.drivers.length > 0) {
          response.drivers.forEach((driver) => {
            markData.push({
              user: driver.driverName,
              lat: driver.driverLocation[0],
              lon: driver.driverLocation[1],
              img: Car,
            });
          });
        }
      })
      .catch((error) => console.error("Error:", error));

    // Only process markers if we have valid data
    if (markData) {
      const markers = markData.map((mark) => ({
        text: mark.user,
        img: mark.img,
        lat: parseFloat(mark.lat),
        lng: parseFloat(mark.lon),
      }));

      this.setState({ markers }, () => {
        this.updateBounds();
        this.setState({ isLoaded: true });
      });
    }
  }

  updateBounds() {
    const { markers, size } = this.state;
    if (markers.length === 0) return;

    const latitudes = markers.map((marker) => marker.lat);
    const longitudes = markers.map((marker) => marker.lng);

    const bounds = {
      ne: { lat: Math.max(...latitudes), lng: Math.max(...longitudes) },
      sw: { lat: Math.min(...latitudes), lng: Math.min(...longitudes) },
    };

    let { center, zoom } = fitBounds(bounds, size);
    zoom = Math.max(8, Math.min(zoom, 16));

    this.setState({
      bounds: { ...bounds, center, zoom },
    });
  }

  render() {
    return (
      <div className="gridItem">
        <div className="gridHeader">
          {/*
          <div className="gridHeaderIcon">
            <img src={Delivery} alt="" />
          </div>
          */}
          <div className="gridHeaderTitle">Volgende levering</div>
          <div className="gridHeaderAll">
            <Link to={"/orders"} className="">
              Bekijk levering
            </Link>
          </div>
        </div>
        <div ref={this.containerRef} className="gridMap">
          <div
            style={{
              height: `${this.state.size.height}px`,
              width: `${this.state.size.width}px`,
              position: "relative",
            }}>
            {this.state.isLoaded ? (
              this.state.markers.length === 0 ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    width: "100%",
                    background: "#f5f5f5",
                    borderRadius: "8px",
                    border: "1px solid #e0e0e0",
                  }}>
                  <div
                    style={{
                      textAlign: "center",
                      color: "#666",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}>
                    Uw locatie kon niet opgehaald worden
                  </div>
                </div>
              ) : (
                <>
                  <GoogleMapReact
                    bootstrapURLKeys={{
                      key: "AIzaSyCvuq_EYSsLuOr3HGKl6q2vWfRX_0p4T5c",
                    }}
                    defaultCenter={this.state.bounds.center}
                    defaultZoom={this.state.bounds.zoom}
                    options={{
                      scrollwheel: false,
                      zoomControl: true,
                      zoomControlOptions: {
                        position:
                          window.google?.maps?.ControlPosition?.RIGHT_BOTTOM,
                      },
                    }}
                    onGoogleApiLoaded={({ map, maps }) => {
                      if (this.state.markers.length > 0) {
                        const bounds = new maps.LatLngBounds();
                        this.state.markers.forEach((marker) => {
                          bounds.extend(
                            new maps.LatLng(marker.lat, marker.lng)
                          );
                        });
                        map.fitBounds(bounds);

                        const padding = {
                          top: 50,
                          right: 50,
                          bottom: 50,
                          left: 50,
                        };
                        map.fitBounds(bounds, padding);

                        if (this.state.markers.length === 2) {
                          const directionsService =
                            new maps.DirectionsService();
                          const directionsRenderer =
                            new maps.DirectionsRenderer({
                              map,
                              suppressMarkers: true,
                            });

                          const request = {
                            origin: new maps.LatLng(
                              this.state.markers[1].lat,
                              this.state.markers[1].lng
                            ),
                            destination: new maps.LatLng(
                              this.state.markers[0].lat,
                              this.state.markers[0].lng
                            ),
                            travelMode: maps.TravelMode.DRIVING,
                          };

                          directionsService.route(request, (result, status) => {
                            if (status === maps.DirectionsStatus.OK) {
                              directionsRenderer.setDirections(result);

                              const duration =
                                result.routes[0].legs[0].duration.text;
                              const arrivalTime = new Date();
                              const durationInMinutes = parseInt(duration);
                              arrivalTime.setMinutes(
                                arrivalTime.getMinutes() + durationInMinutes
                              );

                              const formattedTime =
                                arrivalTime.toLocaleTimeString("nl-NL", {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                });

                              this.setState({
                                eta: `${duration} (Aankomst: ${formattedTime})`,
                              });
                            }
                          });
                        }
                      }
                    }}
                    onChange={({ zoom, center }) => {
                      this.updateBounds();
                    }}>
                    {this.state.markers.map((mark, i) => (
                      <AnyReactComponent
                        key={i}
                        lat={mark.lat}
                        lng={mark.lng}
                        text={mark.text}
                        img={mark.img}
                      />
                    ))}
                  </GoogleMapReact>
                  {this.state.eta && (
                    <div
                      style={{
                        position: "absolute",
                        top: "16px",
                        left: "16px",
                        zIndex: 1000,
                        pointerEvents: "none",
                      }}>
                      <div
                        style={{
                          background: "rgba(255, 255, 255, 0.95)",
                          backdropFilter: "blur(8px)",
                          borderRadius: "8px",
                          padding: "12px 16px",
                          boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                          border: "1px solid rgba(0, 0, 0, 0.1)",
                          maxWidth: "280px",
                        }}>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            marginBottom: "4px",
                            fontWeight: "500",
                          }}>
                          Geschatte aankomsttijd
                        </div>
                        <div
                          style={{
                            fontSize: "14px",
                            color: "#333",
                            fontWeight: "600",
                          }}>
                          {this.state.eta}
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )
            ) : (
              <div>Loading map...</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default GPS;
